import { render } from "./StatisticsWidget.vue?vue&type=template&id=419c29d9&scoped=true"
import script from "./StatisticsWidget.vue?vue&type=script&lang=js"
export * from "./StatisticsWidget.vue?vue&type=script&lang=js"

import "./StatisticsWidget.vue?vue&type=style&index=0&id=419c29d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419c29d9"]])

export default __exports__